<ng-select
    class="ng-select-fill"
    [class.hide-hint]="hideMatHint"
    [items]="statusList$ | async"
    [formControl]="fc"
    [placeholder]="field.name"
    [clearable]="false"
    bindValue="key">
    <ng-template ng-label-tmp let-item="item">
        {{ item.name }}
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div [style.border-color]="'#' + item.color">
            {{ item.name }}
        </div>
    </ng-template>
</ng-select>

@if (!hideMatHint) {
    <mat-error [control]="fc"></mat-error>

    @if (statusChange; as change) {
        <mat-hint class="text-ellipsis">
            {{ change.created_at | date: 'EEE d MMM yyyy' }} -
            {{ (users | byId: change.changed_by_id)?.name ?? 'Onbekend' }}
        </mat-hint>
    }
}
